module.exports = __webpack_public_path__ + "img/snakespear.f1851151.png";